module.exports = __webpack_public_path__ + "static/media/statotech33.a51681be.png";